export const init_purchase_location = "/purchase";
export const url_purchase_dashboard = `${init_purchase_location}/dashboard`;
export const url_purchase_inputs = `${init_purchase_location}/inputs`;
export const url_purchase_orders_manager = `${init_purchase_location}/orders-manager`;
export const url_purchase_suppliers_orders = `${init_purchase_location}/suppliers-orders`;
export const url_purchase_stock = `${init_purchase_location}/stock`;
export const url_purchase_suppliers = `${init_purchase_location}/suppliers-management`;
